import { FC } from 'react';
import { CacheLocation, FpjsProvider } from '@fingerprintjs/fingerprintjs-pro-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider as StoreProvider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import config from 'config';

import { init as initStore } from 'store';
import api from 'services/api';

const { store, persistor } = initStore();

store.subscribe(() => {
  api.init(store);

  return api.init;
});

export const queryClient = new QueryClient();

const AppProvider: FC = ({ children }): JSX.Element => (
  <StoreProvider store={store}>
    <PersistGate persistor={persistor}>
      <QueryClientProvider client={queryClient}>
        <FpjsProvider
          loadOptions={{
            apiKey: config.fingerprintjs.apiKey
          }}
          cacheLocation={CacheLocation.LocalStorage}
        >
          <Router>{children}</Router>
        </FpjsProvider>
      </QueryClientProvider>
    </PersistGate>
  </StoreProvider>
);

export default AppProvider;
